export interface AllowedOriginEntry {
  origin: string;
  hiddenPaths: string[];
}

export function matchAllowedOrigin(
  currentOrigin: string,
  allowedOrigins?: AllowedOriginEntry[],
): AllowedOriginEntry | null {
  if (!allowedOrigins || allowedOrigins.length === 0) {
    return null;
  }

  const exactMatch = allowedOrigins.find((entry) => {
    const normalizedOrigin = entry.origin.replace(/\/+$/, "");
    return normalizedOrigin === currentOrigin;
  });
  if (exactMatch) {
    return exactMatch;
  }

  const wildcardMatch = allowedOrigins.find((entry) =>
    isWildcardOriginMatch(currentOrigin, entry.origin),
  );
  return wildcardMatch || null;
}

function isWildcardOriginMatch(
  currentOrigin: string,
  pattern: string,
): boolean {
  if (!pattern.includes("*")) {
    return false;
  }

  const normalizedPattern = pattern.replace(/\/+$/, "");
  const escapedPattern = normalizedPattern
    .split("*")
    .map((part) => part.replace(/[.+?^${}()|[\]\\]/g, "\\$&"))
    .join(".*");

  const regex = new RegExp(`^${escapedPattern}$`);
  return regex.test(currentOrigin);
}

export function isHiddenPath(
  pathname: string,
  hiddenPaths: string[] = [],
): boolean {
  return hiddenPaths.some((pathPattern) => {
    if (pathPattern.includes("*")) {
      const escapedPattern = pathPattern
        .split("*")
        .map((part) => part.replace(/[.+?^${}()|[\]\\]/g, "\\$&"))
        .join(".*");

      const regex = new RegExp(`^${escapedPattern}$`);
      return regex.test(pathname);
    }

    return pathname === pathPattern;
  });
}
